import ErrorString from './error_string';
import ReCAPTCHA from "react-google-recaptcha-enterprise";

export default function Captcha(props)
{
    const { error, onChange, onErrored, onExpired } = props

    return (
        <>
            <ReCAPTCHA
                sitekey={ process.env.NEXT_PUBLIC_RECAPTCHA_SITEKEY }
                onChange={ onChange }
                onErrored={ onErrored }
                onExpired={ onExpired }
            />
            <ErrorString error={ error } />
        </>
    );
}